import { InputHTMLAttributes, forwardRef, Ref, FocusEvent } from 'react'
import { Eye, EyeHidden } from 'src/assets'
import { useDisclosure } from 'src/utils'
import { useController } from 'react-hook-form'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | React.ReactNode
  // error?: string
  // onBlur?: (e: FocusEvent<HTMLInputElement>) => void
  name: string
}

const Input = (
  { label, className, type, disabled, name, onBlur, ...rest }: Props,
  ref: Ref<HTMLInputElement>
) => {
  const { field, fieldState } = useController({ name })
  const { isOpen, open, close } = useDisclosure(!!field?.value)
  const { isOpen: showPassword, toggle: toggleShowPassword } = useDisclosure()
  const error = fieldState.error?.message

  const classes = [
    'w-full',
    'rounded-sm',
    'relative',
    'bg-light-gray',
    'border-s',
    'transition-all',
    'duration-500',
    'h-[52px]',
    'p-md',
    'pt-xl',
    'focus:outline-none',
    'disabled:text-dark-gray',
    error ? 'border-red' : 'border-light-gray focus:border-black',
    className,
  ]

  const labelClasses = [
    'absolute',
    'left-[15px]',
    'z-10',
    'transition-all',
    'duration-500',
    'truncate ...',
    'w-10/12',
    'pointer-events-none',
    !!isOpen ? 'top-[5px] tiny-normal' : 'top-[15px] base-normal',
    error ? 'text-red' : 'text-dark-gray',
  ]

  const inputType = type === 'password' && showPassword ? 'text' : type

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    !!e.target.value ? open() : close()
    if (onBlur) onBlur(e)
  }

  return (
    <div className='w-full h-fit relative overflow-hidden'>
      <div className='relative'>
        {label && (
          <div className={labelClasses.join(' ')}>{error || label}</div>
        )}
        <input
          ref={ref}
          type={inputType}
          disabled={disabled}
          className={classes.join(' ')}
          onFocus={open}
          onBlur={handleBlur}
          {...rest}
          value={field?.value || ''}
          onChange={field.onChange}
        />
        {type === 'password' && (
          <button
            type='button'
            disabled={disabled}
            onClick={toggleShowPassword}
            className='absolute right-[15px] top-1/2 transform -translate-y-1/2 text-black disabled:text-dark-gray'
          >
            {showPassword ? <Eye className='fill-black' /> : <EyeHidden />}
          </button>
        )}
      </div>
    </div>
  )
}

export default forwardRef(Input)
